import {put, call, take} from "typed-redux-saga";
import {
	fetchLeaderboardFailed,
	fetchLeaderboardSuccess,
	fetchMoreLeaderboard,
	IFetchLeaderboardPayload,
	showGlobalError,
} from "modules/actions";
import {Api} from "modules/utils";
import {ISagaAction} from "modules/types";
import {SagaIterator} from "redux-saga";

export const fetchLeaderboardSaga = function* (
	action: ISagaAction<IFetchLeaderboardPayload>
): SagaIterator {
	try {
		const limit = 20;
		const {payload} = action;
		const result = yield* call(Api.Rankings.leaderboard, {...payload, limit});
		yield* put(fetchLeaderboardSuccess(result.success));

		/**
		 * Load more actions
		 */
		if (result.success.nextPage) {
			const {page} = payload;
			const nextPage = page ? page + 1 : 2;

			yield* take(fetchMoreLeaderboard);
			yield* call(fetchLeaderboardSaga, {
				...action,
				payload: {
					...payload,
					page: nextPage,
					limit,
				},
			});
		}
	} catch (err) {
		const {message} = err as Error;
		yield* put(fetchLeaderboardFailed(message));
		yield* put(showGlobalError(err as Error));
	}
};
